import { Link } from '@tanstack/react-router'

import { Card, Page } from '@/components/layout'
import { useT } from '@/lib/i18n/translate'

/** Any URL the route tree does not match (stale pre-D9 bookmarks, typos). */
export function NotFoundPage({ home }: { home: '/' | '/app' }) {
  const t = useT()
  return (
    <Page width="sm" className="pt-10">
      <Card className="flex flex-col items-center gap-4 p-6">
        <h1 className="text-xl font-semibold">{t('notFound.title')}</h1>
        <Link to={home} className="text-accent-ink font-medium hover:underline">
          {t('notFound.home')}
        </Link>
      </Card>
    </Page>
  )
}
